import { TYPES } from "./credit_redeem.type";

const initState = {
  all: null,
};

const creditRedeemReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SELECT_ALL_NOTES:
      return {
        ...state,
        all: payload,
      };

    default:
      return state;
  }
};

export default creditRedeemReducer;
